import React from "react";
import { Phone, MapPin, Clock } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-white">
      <div className="container mx-auto px-6 md:px-12">
        <div className="py-14 border-b border-slate-800 grid md:grid-cols-2 gap-8 items-center">
          <h3 className="font-display font-black text-3xl md:text-4xl tracking-tighter leading-tight">
            Ready for the cleanest your car<br />has ever been?
          </h3>
          <div className="flex flex-wrap gap-4 md:justify-end">
            <a href="#book" data-testid="footer-book-cta" className="inline-flex items-center bg-blue-600 hover:bg-blue-700 px-6 py-3.5 text-sm font-bold transition-all hover:-translate-y-0.5">
              Book online
            </a>
            <a href="tel:5416222960" data-testid="footer-call-cta" className="inline-flex items-center gap-2 border-2 border-white px-6 py-3.5 text-sm font-bold hover:bg-white hover:text-slate-900 transition-all hover:-translate-y-0.5">
              <Phone size={16} /> 541-622-2960
            </a>
          </div>
        </div>

        <div className="py-16 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 bg-blue-600 grid place-items-center text-white font-display font-black">SO</div>
              <div>
                <div className="font-display font-black text-xl tracking-tight">Southern Oregon Detailing</div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-blue-400 font-semibold">Mobile auto detailing</div>
              </div>
            </div>
            <p className="mt-5 text-slate-400 text-sm max-w-sm leading-relaxed">
              Locally owned, fully insured mobile detailing serving Medford and
              the Rogue Valley. Hand finished results, every wash, every time.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-blue-400 mb-5">Get in touch</div>
            <ul className="space-y-4 text-sm text-slate-300">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-blue-400 mt-0.5" />
                <a href="tel:5416222960" className="hover:text-white">541-622-2960</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-blue-400 mt-0.5" />
                <span>Medford, Oregon</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="text-blue-400 mt-0.5" />
                <span>Mon to Sun · 8am to 6pm</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-blue-400 mb-5">Service areas</div>
            <p className="text-sm text-slate-300 leading-relaxed">
              Medford · Ashland · Grants Pass · Central Point · Jacksonville ·
              Phoenix · Talent · Eagle Point · White City · Shady Cove · Gold
              Hill · Rogue River
            </p>
          </div>
        </div>

        <div className="py-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Southern Oregon Detailing. All rights reserved.</div>
          <div>Made with care in the Rogue Valley.</div>
        </div>
      </div>
    </footer>
  );
}
